import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { QuestionnairesReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const questionnairesReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...QuestionnairesReducerHandlers.fetchQuestionnaireByCustomerId,
    ...QuestionnairesReducerHandlers.updateQuestionnaireByCustomer,
    ...QuestionnairesReducerHandlers.getQuestionnaireByProjectId,
    ...QuestionnairesReducerHandlers.createQuestionnaire,
  },
);

export default questionnairesReducer;
